"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStep = exports.addStep = void 0;
const models_1 = require("../../models");
const addStep = (state, payload) => {
    state.value.push(payload);
};
exports.addStep = addStep;
const removeStep = (state, indexToRemove) => {
    const stepsDisplayed = state.value;
    stepsDisplayed.splice(indexToRemove, 1);
    let i = 1;
    while (indexToRemove - i > 0 &&
        stepsDisplayed[indexToRemove - i].answerType === models_1.InputType.NO_INPUT) {
        stepsDisplayed.splice(indexToRemove - i, 1);
        i += 1;
    }
};
exports.removeStep = removeStep;
//# sourceMappingURL=stepsDisplayed.js.map